<template>
  <v-dialog
    v-model="isVisible"
    no-click-animation
    :width="'55%'"
  >
    <v-card>
      <v-card-title>
        <h3>簡易進件</h3>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field v-model="profile.name"
                          placeholder="請輸入姓名" label="姓名">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field v-model="profile.memberId"
                          placeholder="請輸入身分證" label="身分證">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field v-model="profile.carId"
                          placeholder="請輸入車牌號碼" label="車牌號碼">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <drag-view @dragFinish="dragImageResult">
              <div class="dropbox">
                <input type="file" ref="file" multiple :name="uploadFieldName"
                       @change="filesChange($event.target.name, $event.target.files);"
                       accept="image/*,.pdf" class="input-file">
                <p>
                  將圖片或PDF(一張或多張)拖到此處<br> 或點擊上傳
                </p>
              </div>
            </drag-view>
          </v-flex>
        </v-layout>
        <v-layout v-if="uploadedFiles.length">
          <v-flex>
            <ul>
              <li v-for="file of uploadedFiles">
                {{file.name}}
              </li>
            </ul>

          </v-flex>
        </v-layout>
        <br>
        <v-layout>
          <v-flex>
            <span style="color: red">{{ message }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn class="red" dark text @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadView from '@/components/UploadView.vue';
import DragView from '@/components/DragView.vue';
import AttachmentModel from '@/models/AttachmentModel';
import common from '@/mixins/common.vue';

export default {
  name: 'SimpleApplyDialog',
  components: { UploadView, DragView },
  props:{
    visible: Boolean,
  },
  data() {
    return {
      uploadedFiles: [],
      uploadFieldName: 'photos',
      profile: {
        name: '',
        memberId: '',
        carId: '',
        imageList:[]
      },
      isVisible: false,
      message: '',
    }
  },
  mixins:[common],
  watch: {
    visible(value) {
      this.isVisible = value;
    },
    isVisible(value) {
      if (value) {
        this.reset();
      } else {
        this.cancelEvent();
      }
    },
  },
  methods: {
    dragImageResult(files){
      console.log(`dragImageResult = ${files.length}`)
      if (files.length > 0){
        this.filesChange(this.uploadedFiles, files);
      }
    },
    reset(){
      this.profile = {
        name: '',
        memberId: '',
        carId: '',
      };
      this.message = '';
    },
    cancelEvent(){
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
    async confirmEvent(){
      if (this.profile.name === ''){
        this.message = '請輸入姓名';
        return;
      }
      if (this.profile.memberId === ''){
        this.message = '請輸入身分證';
        return;
      }
      this.isVisible = false;
      await this.upload();

      this.$emit('confirmEvent', this.profile);
    },
    filesChange(fieldName, fileList) {

      if (!fileList.length) return;

      if (this.profile.memberId === ''){
        this.message = '請輸入身份證';
        this.$refs.file.value = null;
        return;
      }

      const files = Object.values(this.$refs.file.files);
      const formData = new FormData();

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        // eslint-disable-next-line
        .map((i ,x) => {
          formData.append(fieldName, fileList[x], fileList[x].name);

          const file = { name: fileList[x].name, image: fileList[x],
            size: fileList[x].size, type: fileList[x].type };

          this.createImage(i, file , fileList.length - 1);
        });
    },
    createImage(i , file, total) {
      console.log('== files6 ==');
      const reader = new FileReader();
      const fileName = file.name;
      console.log(`=== createImage fileName === ${fileName} `);
      reader.onload = (e) => {
        const image = e.target.result;
        const filItem = { name:fileName, image };
        this.uploadedFiles.push(filItem);
      };
      reader.readAsDataURL(file.image);
    },
    async upload() {
      console.log(`upload count === ${this.uploadedFiles.length}`);
      if (this.uploadedFiles && this.uploadedFiles.length > 0) { // 是否有圖片要上傳
        this.saveLoading = true;
        let uploadCount = 0;

        this.uploadedFiles.forEach((item) => {
          // console.log(`user === ${this.itemDetail.caseId} image = ${item.image}`);
          const path = `${this.profile.memberId}/${item.name}`;
          this.$store.dispatch('uploadImageData', {
            name: `caseImages/${path}`,
            image: item.image,
          }).then((response) => {
            console.log(`uploadImageData success ${JSON.stringify(response)}`);
            uploadCount += 1;
            // 處理完成更新資料
            if (this.uploadedFiles.length === uploadCount) {
              this.profile.imageList.push(response)
            }
          }, (error) => {
            console.log(`uploadImageData error ${JSON.stringify(error)}`);
            uploadCount += 1;
            if (this.uploadedFiles.length === uploadCount) {
              this.saveLoading = false;
            }
          });
        });
      }
    },
  }
};
</script>

<style scoped>
.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%,20%,40%,0.5);

}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {

  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden
}


.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleApplyDialog.vue